'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _information = require('./information.html');

var _information2 = _interopRequireDefault(_information);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _information2.default,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    administrationUnits: '<',
    categories: '<',
    copyAreas: '<',
    onProductLabelChanged: '&',
    locked: '<',
    viewOnly: '<',
    product: '<',
    unitsDisplay: '<',
    onLoadingDoseRequiredChanged: '&',
    onDateFirstSoldChanged: '&',
    showHeader: '<',
    labelValid: '<'
  },
  controller: function () {
    function InformationComponent(EventEmitter) {
      'ngInject';

      _classCallCheck(this, InformationComponent);

      Object.assign(this, { EventEmitter: EventEmitter });
    }

    _createClass(InformationComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.labelChanged = false;
        this.maxDate = new Date();
      }
    }, {
      key: 'loadingDoseRequiredChanged',
      value: function loadingDoseRequiredChanged(required) {
        this.onLoadingDoseRequiredChanged(this.EventEmitter({
          loadingDoseRequired: required
        }));
      }
    }, {
      key: 'dateFirstSoldChanged',
      value: function dateFirstSoldChanged(dateFirstSold) {
        this.onDateFirstSoldChanged(this.EventEmitter({
          dateFirstSold: dateFirstSold
        }));
      }
    }, {
      key: 'productLabelChanged',
      value: function productLabelChanged(_ref) {
        var productLabel = _ref.productLabel;

        this.labelChanged = true;
        this.onProductLabelChanged(this.EventEmitter({
          productLabel: productLabel
        }));
      }
    }]);

    return InformationComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/product/information/information.component.js